import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/support.svg'


const _withScopeId = n => (_pushScopeId("data-v-459f5667"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  href: "https://support.ubiant.com",
  target: "_blank",
  class: "pannel relative"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flex p-3 align-items-center h-full\" data-v-459f5667><div class=\"bg-default-gray p-2 mr-3 border-round-md\" data-v-459f5667><img src=\"" + _imports_0 + "\" data-v-459f5667></div><div class=\"flex flex-column\" data-v-459f5667><h2 data-v-459f5667>Besoin d&#39;assistance ?</h2><span class=\"app-label text-default-gray font-bold\" data-v-459f5667>Un espace en ligne et une hotline gratuite pour une assistance personnalisé</span></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardTopRightButton = _resolveComponent("CardTopRightButton")!

  return (_openBlock(), _createElementBlock("a", _hoisted_1, [
    _createVNode(_component_CardTopRightButton, { icon: "ci-arrows-back" }),
    _hoisted_2
  ]))
}